import { type TracksListPageTabsKeys } from './tabs'

export const emptyListMessages: Record<TracksListPageTabsKeys, string> = {
  music: 'В списке пока нет ни одной музыки',
  podcast: 'В списке пока нет ни одного подкаста',
  sermon: 'В списке пока нет ни одной проповеди',
  audiobook: 'В списке пока нет ни одной аудиокниги',
} as const

export const addNewMessages: Record<TracksListPageTabsKeys, string> = {
  music: 'Добавить новую музыку',
  podcast: 'Добавить новый подкаст',
  sermon: 'Добавить новую проповедь',
  audiobook: 'Добавить новую аудиокнигу',
} as const
